import { render, staticRenderFns } from "./OrderGoods.vue?vue&type=template&id=4c562a54"
import script from "./OrderGoods.vue?vue&type=script&lang=js"
export * from "./OrderGoods.vue?vue&type=script&lang=js"
import style0 from "./OrderGoods.vue?vue&type=style&index=0&id=4c562a54&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports